/**
 * Spacing design tokens
 * Consistent spacing values used across all themes
 */
export const spacing = {
  none: '0rem',
  tiny: '0.25rem',
  small: '0.5rem',
  compact: '0.75rem',
  base: '1rem',
  medium: '1.25rem',
  comfort: '1.5rem',
  generous: '1.75rem',
  large: '2rem',
  extraLarge: '2.5rem',
  huge: '3rem',
  giant: '3.5rem',
  ultra: '3.75rem',
  mega: '5rem',
  massive: '6.25rem',
} as const;

export type SpacingKey = keyof typeof spacing;
